export default __webpack_public_path__ + "static/media/NRLevel4LeftSideMap.9ee999bf.jpg";